var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"put-account"}},[_c('a-tabs',{attrs:{"activeKey":_vm.tab_key,"type":"card","tabBarGutter":10},on:{"change":_vm.callback}},_vm._l((_vm.showTabData),function(item,index){return _c('a-tab-pane',{key:item.keys,attrs:{"tab":item.name}})}),1),_c('div',{staticStyle:{"padding":"0 15px 15px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }